import { render, staticRenderFns } from "./BidFailedNotificationsLogs.vue?vue&type=template&id=3be9aa68&"
import script from "./BidFailedNotificationsLogs.vue?vue&type=script&lang=js&"
export * from "./BidFailedNotificationsLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports